import React, { Component } from 'react'
import config from '../config.json'
import OverviewFilter from './OverviewFilter/index'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import hasFilter from '../hoc/hasFilter.jsx'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails.jsx'
import { trackUiOverviewChangeView } from '../tracking'
import OverviewTitle from './OverviewTitle'
import WeischerItemsList from '../Weischer/WeischerItemsList'
import { Redirect } from 'react-router-dom'
import getWeischerData from '../functions/getWeischerData'
import { GRID_ELEMENT, LIST_ELEMENT, OVERVIEW_ELEMENT, SHOWTIMES_ELEMENT } from '../constants/mobileFrontElements'
import OverviewViewSwitch from './OverviewViewSwitch'
import hasPerformancePerCinemaFilter from '../hoc/hasPerformancePerCinemaFilter'
import PerformancePerCinemaFilters from '../MovieInformation/PerformancePerCinemaFilters'
import { MULTICINEMA } from '../constants/multiCinemaModes'
import AdvertisementsBannerList from '../Advertisements/AdvertisementsBannerList'
import { ADVERTISEMENT_INTERSCROLLER, ADVERTISEMENT_OVERVIEW_BANNER } from '../constants/advertisementTypes'
import getAdvertisementData from '../functions/getAdvertisementData'
import toJS from '../hoc/toJS.jsx'
import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData.js'
import { CLI_CURRENT_CINEMA_ID, FRONT, UI_TRAILER } from '../constants/state.js'

const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation']),
    cinemaDataFront: getData(state, FRONT),
    cinemaFrontPk: getData(state, CLI_CURRENT_CINEMA_ID)
})
class Overview extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeView: 'none'
        }

        this.onChangeOverviewView = this.onChangeOverviewView.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        const { queryStringValues, customMobilePageActive, customMobilePageType, programOverviewStartviewType, hasYoutubeCookieConfirmation, overviewStartView } = props
        const startView = Overview.getStartView(programOverviewStartviewType, hasYoutubeCookieConfirmation)
        
        if('none' === state.activeView) {
            let view = startView
            
            if(queryStringValues && queryStringValues.id) {
                view = 'list'
            } else if(customMobilePageActive) {
                if(customMobilePageType === GRID_ELEMENT) {
                    view = 'grid'
                } else if(customMobilePageType === LIST_ELEMENT) {
                    view = 'list'
                } else if(customMobilePageType === SHOWTIMES_ELEMENT) {
                    view = 'showtimes'
                }
            } else if(customMobilePageType === OVERVIEW_ELEMENT) {
                view = overviewStartView
            }

            return {
                activeView: view
            }
        }

        return null
    }

    static getStartView(programOverviewStartviewType, hasYoutubeCookieConfirmation) {

        let view = 'grid'

        if(programOverviewStartviewType) {
            if('grid-trailer' === programOverviewStartviewType) {
                if(true === hasYoutubeCookieConfirmation) {
                    view =  programOverviewStartviewType
                } else if(false === hasYoutubeCookieConfirmation) {
                    view = 'grid'
                } else {
                    view = 'none'
                }
            } else {
                view = programOverviewStartviewType
            }
        }

        return view
    }

    componentDidUpdate(prevProps) {
        const { customMobilePageActive, queryStringValues, programOverviewStartviewType, hasYoutubeCookieConfirmation } = this.props

        if(
            !customMobilePageActive &&
            !(queryStringValues && queryStringValues.id) &&
            'grid-trailer' === programOverviewStartviewType &&
            true !== prevProps.hasYoutubeCookieConfirmation && 
            true === hasYoutubeCookieConfirmation
        ) {
            this.setState({
                activeView: hasYoutubeCookieConfirmation ? programOverviewStartviewType : 'grid'
            })
        }
    }

    getRedirectPath() {
        const { activeFilters, allItems, match } = this.props

        if(activeFilters.hasOwnProperty('id')) {
            const movieId = activeFilters.id[0]
            const titleFilterItems = allItems.titleFilter.items
            const titleFilterItemsKeys = Object.keys(titleFilterItems)
            const titleFilterItemsKeysLength = titleFilterItemsKeys.length

            let movieParam = false

            for (let i = 0; i < titleFilterItemsKeysLength; i++) {
                const itemKey = titleFilterItemsKeys[i]
                const itemMovieIds = titleFilterItems[itemKey]

                if(itemMovieIds.includes(movieId)) {
                    movieParam = itemKey
                    break
                }
            }

            if(movieParam) {
                return "/" + match.params.overviewParam + '/movie/' + movieParam
            }
        }

        return false
    }

    getSearchParams() {
        const { overviewFilterName, overviewFilterType, activeFilters, filterWasSetViaRedirect } = this.props
        if(_.isEmpty(activeFilters) && overviewFilterName && overviewFilterType && !filterWasSetViaRedirect) {
            return `?${overviewFilterType}=${overviewFilterName}`
        }

        return false
    }

    onChangeOverviewView({view}) {
        if(this.state.activeView !== view) {
            this.setState({
                activeView: view
            })
        }
    }

    render() {
        const { 
            movies,
            elbenwald,
            siteHeaderData, 
            displaySidebarRight, 
            displaySidebarRightSecond, 
            onSidebarRightOpen, 
            onSidebarRightClose, 
            allItems,  
            translation,
            routesData,
            activeFilters, 
            activePerformance, 
            performancePageOpen, 
            attributeStyling,
            filterDisplay, 
            dayFilterDisplay,
            openFilter,
            dayFilters,
            searchFilter,
            queryStringValues,
            toggleFilter,
            informationStyling,
            onCloseDetails,
            onOpenDetails,
            onOpenDetailsFirstSidebar,
            onCloseDetailsFirstSidebar,
            onCloseInformation,
            onOpenPerformancePage,
            onClosePerformancePage,
            activeItem,
            activeDetailsItem,
            onOpenInformation,
            stripeAppearance,
            overviewSubtitle,
            programOverviewShowtimesType,
            detailsStyling,
            items,
            theme,
            features,
            openDayFilter,
            toggleDayFilter,
            programOverviewListStyle,
            filters,
            hiddenAttributes,
            posterStyling,
            activeItemIndex,
            weischerAds,
            ignoreAttributesForPerformanceFilter,
            overviewFilterIgnoreOnPerformances,
            advertisements,
            hasShowtimesFeature,
            hasGridTrailerFeature,
            isMobile,
            hasGridHoverTrailer,
            customMobilePageActive,
            additionalScrollName,
            activeCinema,
            clusterCinemaOption,
            clusterCinemaName,
            clusterCinemas,
            cinemas,
            currentCinemaPk,
            setActiveCinema,
            isConnectedFast,
            hasYoutubeCookieConfirmation,
            cinemaFrontPk
        } = this.props
        const { activeView } = this.state

        if(_.isEmpty(allItems)) {
            return ''
        }

        const redirectPath = this.getRedirectPath()
        const searchParams = this.getSearchParams()

        if(redirectPath) {
            return <Redirect
                to={{
                    pathname: redirectPath,
                    search: null
                }}
            />
        }
        
        if(searchParams) {
            const pathname = this.props.location.pathname

            return <Redirect
                to={{
                    pathname: pathname,
                    search: searchParams
                }}
            />
        }

        const { overviewWeischerAds, interscrollerWeischerAds } = getWeischerData(weischerAds)
        const currentCinema = currentCinemaPk ? cinemas[currentCinemaPk] : null
        const currentCinemaType = currentCinema ? currentCinema.scope.type : null
        const cinemaFrontPkType = cinemaFrontPk && cinemas[currentCinemaPk] ? cinemas[currentCinemaPk].scope.type : null 
        const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) && currentCinemaPk === activeCinema ? true : false
        const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_OVERVIEW_BANNER, ADVERTISEMENT_INTERSCROLLER]) 
        const view = activeView

        return (
            <div className={"overview overview-view-" + view}>
                {!customMobilePageActive && <OverviewTitle singleMovie={false} overviewSubtitle={overviewSubtitle} notFound={false} items={items} movies={movies} translation={translation} />}
  
                {!customMobilePageActive && <OverviewFilter 
                    siteHeaderData={siteHeaderData}
                    filterDisplay={filterDisplay}
                    dayFilterDisplay={dayFilterDisplay}
                    informationStyling={informationStyling}
                    allItems={items}
                    cinemaFrontPkType={cinemaFrontPkType}
                    movies={movies}
                    theme={theme}
                    filters={filters}
                    dayFilters={dayFilters}
                    activeView={activeView}
                    searchFilter={searchFilter}
                    activeFilters={activeFilters}
                    queryStringValues={queryStringValues}
                    openFilter={openFilter}
                    onChangeOverviewView={trackUiOverviewChangeView(this.onChangeOverviewView, 'Programm')}
                    toggleFilter={toggleFilter}
                    toggleDayFilter={toggleDayFilter}
                    openDayFilter={openDayFilter}
                    translation={translation}
                    hasShowtimesFeature={hasShowtimesFeature}
                    hasGridTrailerFeature={hasGridTrailerFeature && true === hasYoutubeCookieConfirmation}
                />}

                {(clusterCinemaOption || currentCinemaType === MULTICINEMA) && <div className='grid-site-wrapper'><PerformancePerCinemaFilters
                    clusterCinemaOption={clusterCinemaOption}
                    activeCinema={activeCinema}
                    clusterCinemaName={clusterCinemaName}
                    currentCinemaType={currentCinemaType}
                    clusterCinemas={clusterCinemas}
                    setActiveCinema={setActiveCinema}
                    cinemas={cinemas}
                    translation={translation}
                    currentCinemaPk={currentCinemaPk}
                /></div>}

                {!siteHeaderData.isFrontPage && !customMobilePageActive && (
                    <>
                        <WeischerItemsList weischerAdsList={overviewWeischerAds} />
                        <AdvertisementsBannerList items={filteredAdvertisements[ADVERTISEMENT_OVERVIEW_BANNER]} />
                    </>
                )}

                <OverviewViewSwitch
                    view={view}
                    additionalScrollName={additionalScrollName}
                    queryStringValues={queryStringValues}
                    isMobile={isMobile}

                    selectionId="program"
                    activeSelection="program"

                    clusterCinemaActive={clusterCinemaActive}
                    clusterCinemaOption={clusterCinemaOption}
                    activeCinema={activeCinema}
                    currentCinemaType={currentCinemaType}

                    activeItem={activeItem}
                    activeItemIndex={activeItemIndex}
                    items={items}
                    itemsData={movies}
                    elbenwald={elbenwald}
                    
                    interscrollerWeischerAds={interscrollerWeischerAds}
                    interscrollerAdvertisements={filteredAdvertisements[ADVERTISEMENT_INTERSCROLLER]}
                    
                    activeFilters={activeFilters}
                    dayFilters={dayFilters}
                    
                    attributeStyling={attributeStyling}
                    informationStyling={informationStyling}
                    detailsStyling={detailsStyling}
                    posterStyling={posterStyling}
                    programOverviewShowtimesType={programOverviewShowtimesType}
                    hiddenAttributes={hiddenAttributes}
                    hasGridHoverTrailer={hasGridHoverTrailer}
                    theme={theme}
                    stripeAppearance={stripeAppearance}
                    features={features}
                    ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                    programOverviewListStyle={programOverviewListStyle}
                    overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    
                    translation={translation}
                    moviesRoutesData={routesData.movies.items}

                    onOpenInformation={onOpenInformation}
                    onCloseInformation={onCloseInformation}

                    activeDetailsItem={activeDetailsItem}
                    onCloseDetails={onCloseDetails}
                    onOpenDetails={onOpenDetails}
                    onOpenDetailsFirstSidebar={onOpenDetailsFirstSidebar}
                    onCloseDetailsFirstSidebar={onCloseDetailsFirstSidebar}

                    activePerformance={activePerformance}
                    performancePageOpen={performancePageOpen}
                    onOpenPerformancePage={onOpenPerformancePage}
                    onClosePerformancePage={onClosePerformancePage}

                    displaySidebarRight={displaySidebarRight}
                    displaySidebarRightSecond={displaySidebarRightSecond}
                    onSidebarRightOpen={onSidebarRightOpen}
                    onSidebarRightClose={onSidebarRightClose}

                    isConnectedFast={isConnectedFast}
                />
            </div>
        )
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(hasSlidebarRightAndSecond({breakpoint: config.breakpoints.slidebarRight})(hasPerformancePerCinemaFilter(hasFilter(hasOpenInformationAndDetails(Overview)))))
